export default __webpack_public_path__ + "static/media/arrow-slide-L.ac9149b6.svg";